module.exports = __webpack_public_path__ + "static/img/beian.a9fc5860.png";